import type { TypedDocumentNode } from '@apollo/client';
import { gql } from '@apollo/client';

import { Details } from '#src/components/shopItems/ShopItemPicker/ItemPreviewDialog/Details/index.tsx';
import { ItemImagePreview } from '#src/components/shopItems/ShopItemPicker/ItemPreviewDialog/ItemImagePreview/index.tsx';

import type { DefaultContent_clubShopItem } from './__generated__/index.graphql.ts';

type Props = {
  item: DefaultContent_clubShopItem;
  itemEquipped?: boolean;
};

export const DefaultContent = ({ item, itemEquipped }: Props) => {
  return (
    <>
      <ItemImagePreview
        pictureUrl={item.pictureUrl}
        name={item.name}
        type={item.position}
      />
      <Details item={item} itemEquipped={itemEquipped} />
    </>
  );
};

DefaultContent.fragments = {
  clubShopItem: gql`
    fragment DefaultContent_clubShopItem on ClubShopItem {
      ... on ShopItemInterface {
        id
        pictureUrl
        name
        position
      }
      ...Details_shopItem
    }
    ${Details.fragments.shopItem}
  ` as TypedDocumentNode<DefaultContent_clubShopItem>,
};
